import moment from "moment";

export function isDateLaterThanNow(date) {

  if (!date) return true;

  const now = new Date();
  const newDate = new Date(date);

  const nowConverted = now.setDate(now.getDate());
  const dateConverted = newDate.setDate(newDate.getDate());

  return dateConverted > nowConverted;
}

export function isDateTodayOrLater(date) {

  if (!date) return true;

  const now = new Date();
  const newDate = new Date(date);

  const nowConverted = now.setDate(now.getDate());
  const dateConverted = newDate.setDate(newDate.getDate()+1);

  return dateConverted >= nowConverted;
}

// moment.locale() --- en-gb
// moment().format('LT') --- 10:44
// moment().format('LTS') --- 10:44:17
// moment().format('L') --- 27/03/2019
// moment().format('l') --- 27/3/2019
// moment().format('LL') --- 27 March 2019
// moment().format('ll') --- 27 Mar 2019
// moment().format('LLL') --- 27 March 2019 10:44
// moment().format('lll') --- 27 Mar 2019 10:44
// moment().format('LLLL') --- Wednesday, 27 March 2019 10:44
// moment().format('llll') --- Wed, 27 Mar 2019 10:46

export const dateConverter = ( date, format = 'L' ) => {

    const dateFormat = localStorage.getItem('site_of_origin') === 'us' ? 'en-us' : 'en-gb';

    moment.locale( dateFormat );
    return moment( date ).format( format );

}



// WEBPACK FOOTER //
// src/client/helpers/dateHelpers.js